var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.33984H7L7 6.92729L7.35294 10.3398H8.64706L9 6.92729V3.33984ZM8 11.3398C7.38824 11.3398 7 11.6373 7 12.3398C7 13.0424 7.38824 13.3398 8 13.3398C8.61176 13.3398 9 13.0424 9 12.3398C9 11.6373 8.61176 11.3398 8 11.3398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterExclamationMark);
export default __webpack_public_path__ + "static/media/toaster-exclamation-mark.ac3d0febdfa78089067e984b27234f81.svg";
export { ForwardRef as ReactComponent };